import React from "react";
import { useNavigate, useLocation } from "react-router-dom";


function BottomNav() {
    const navigate = useNavigate();
    const location = useLocation();
  
    const links = [
      { label: "Home", path: "/" },
      { label: "Why Us?", path: "/why-us" },
      { label: "What we Do?", path: "/what-we-do" },
      { label: "How we Do?", path: "/ad-touchpoints" },
    ];
  
    return (
      <div className="bottom-nav">
        {links.map((item, i) => {
          const isActive =
            location.pathname === item.path ||
            (item.path === "/" && location.pathname === "/home");
          return (
            <button
              key={i}
              onClick={() => navigate(item.path)}
              className={`nav-btn ${isActive ? "active" : ""}`}
            >
              {item.label}
            </button>
          );
        })}
      </div>
    );
  }
  
  export default BottomNav;